export enum SpendingLinks {
  Update = "updateSpendingDetail",
  Delete = "deleteSpendingDetail",
  AddAnother = "addSpendingOnSameTransaction",
}
